import Colors from "PFTheme/tokens/colors";

export enum ProfileCompletionLevel {
  Poor = "poor",
  Fair = "fair",
  Good = "good",
  Excellent = "excellent"
}

export const ProfileCompletionThresholds = {
  25: ProfileCompletionLevel.Poor,
  50: ProfileCompletionLevel.Fair,
  75: ProfileCompletionLevel.Good,
  100: ProfileCompletionLevel.Excellent
};

export const PROFILE_COMPLETION_COLORS = {
  [ProfileCompletionLevel.Poor]: Colors.paletteRed0,
  [ProfileCompletionLevel.Fair]: Colors.paletteOrange0,
  [ProfileCompletionLevel.Good]: Colors.paletteGreen0,
  [ProfileCompletionLevel.Excellent]: Colors.paletteGreen0
};
